import instance from "./AxiosInstance/unAuthenticated";
import authenticatedInstance from "./AxiosInstance/authenticated";
import { toast } from "sonner";
import {
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signInWithPopup,
  signInWithEmailAndPassword,
  OAuthProvider,
  sendPasswordResetEmail,
  confirmPasswordReset,
} from "firebase/auth";
import { auth } from "../../firebase-config";
import { GoogleAuthProvider } from "firebase/auth";

const googleAuthProvider = new GoogleAuthProvider();
const appleAuthprovider = new OAuthProvider("apple.com");

const handleGoogleSignin = async (uid, userEmail, userName) => {
  try {
    const { data } = await instance.post("/user", { uid });
      if (data?.user?.subscriptionActive) {
        localStorage.setItem("accessToken", data.accessToken);
        toast.success("Logged in successfully!");
        return {
          email: data?.user?.email,
          name: data?.user?.name,
          subscriber: true,
        };
      }
      localStorage.setItem("accessToken", data.accessToken);
      toast.error("Subscription not found!");
      return { email: userEmail, name: userName };
  } catch (error) {
    if (error.response?.status === 400 || error.response?.status === 404) {
      toast.error("Account with this Google account is not found!");
      return false;
    }
    toast.error("Something went wrong!");
    return false;
  }
 
};

const handleAppleSignin = async (uid, userEmail, userName) => {
  try {
    const { data } = await instance.post("/user", { uid });
      if (data?.user?.subscriptionActive) {
        localStorage.setItem("accessToken", data.accessToken);
        toast.success("Logged in successfully!");
        return {
          email: data?.user?.email,
          name: data?.user?.name,
          subscriber: true,
        };
      }
      localStorage.setItem("accessToken", data.accessToken);
      toast.error("Subscription not found!");
      return { email: userEmail, name: data?.user?.name };
  } catch (error) {
    if (error.response?.status === 400 || error.response?.status === 404) {
      toast.error("Account with this Apple account is not found!");
      return false;
    }
    toast.error("Something went wrong!");
    return false;
  }
 
};

export const handleSignIn = async ({ email, password }) => {
  try {
    const user = await signInWithEmailAndPassword(auth, email, password);
    if (user) {
      const { data, status } = await instance.post("/user", {
        uid: user?.user?.uid,
      });
      if (status === 200) {
        if (data?.user?.subscriptionActive) {
          localStorage.setItem("accessToken", data.accessToken);
          toast.success("Logged in successfully!");
          return { success: true, redirect: "/dashboard", user: data?.user };
        } else {
          localStorage.setItem("accessToken", data.accessToken);
          toast.error("subscription not found!");
          return {
            success: true,
            redirect: "/payment-options",
            user: data?.user,
          };
        }
      } else {
        toast.error("Invalid credentials!");
        return { success: false, redirect: "/signin" };
      }
    } else {
      toast.error("Invalid credentials!");
      return { success: false, redirect: "/signin" };
    }
  } catch (error) {
    console.log(error, "Error in signin");
    toast.error("Invalid credentials!");
    return { success: false, redirect: "/signin" };
  }
};

export const handleSignUp = async ({ email, password, name }) => {
  try {
    const user = await createUserWithEmailAndPassword(auth, email, password);
    const { data, status } = await instance.post("/user/signup", {
      name: name,
      email: email.toLowerCase(),
      uid: user?.user?.uid,
    });
    if (status === 200) {
      // add this user as a lead if its a referred user
      if (window.tolt_referral) {
        window.tolt.signup(email.toLowerCase());
      }
      localStorage.setItem("accessToken", data.accessToken);
      toast.success("Signed up successfully!");
      return true;
    }
  } catch (error) {
    console.log("Error in signup", error.message);
    if (error.message === "Firebase: Error (auth/email-already-in-use).") {
      toast.error("Email is already in use!");
    } else {
      toast.error("Something went wrong!");
    }
    return false;
  }
};

export const handleGoogleAuth = async (type) => {
  let user = null;
  try {
    user = await signInWithPopup(auth, googleAuthProvider);
    if (type === "signup" && user?.user) {
      const { data, status } = await instance.post("/user/signup", {
        name: user?.user?.displayName,
        email: user?.user?.email,
        uid: user?.user?.uid,
      });
      if (status === 200) {
        localStorage.setItem("accessToken", data.accessToken);
        toast.success("Signed up successfully!");
        return { email: user?.user?.email, name: user?.user?.displayName };
      }
    } else {
      return await handleGoogleSignin(user?.user?.uid, user?.user?.email, user?.user?.displayName);
    }
  } catch (error) {
    console.log(error, "Error in googleAuth");
    if (type === "signup" && error.response?.status === 400 && user) {
      try {
        return await handleGoogleSignin(user?.user?.uid, user?.user?.email, user?.user?.displayName);
      } catch (signinError) {
        console.log(signinError, "Error in fallback signin");
        toast.error("Something went wrong!");
        return false;
      }
    }
    toast.error("Something went wrong!");
    return false;
  }
};
export const handleAppleAuth = async (type) => {
  let user = null;
  try {
    user = await signInWithPopup(auth, appleAuthprovider);
    if (type === "signup" && user?.user) {
      const name = user?.user?.displayName || user?.user?.email.split("@")[0];
      const { data, status } = await instance.post("/user/signup", {
        name: name,
        email: user?.user?.email,
        uid: user?.user?.uid,
      });
      if (status === 200) {
        localStorage.setItem("accessToken", data.accessToken);
        toast.success("Signed up successfully!");
        return { email: user?.user?.email, name: name };
      }
    } else {
      return await handleAppleSignin(user?.user?.uid, user?.user?.email, user?.user?.displayName);
    }
  } catch (error) {
    console.log(error, "Error in appleAuth");
    if (type === "signup" && error.response?.status === 400 && user) {
      try {
        return await handleAppleSignin(user?.user?.uid, user?.user?.email, user?.user?.displayName);
      } catch (signinError) {
        console.log(signinError, "Error in fallback signin");
        toast.error("Something went wrong!");
        return false;
      }
    }
    toast.error("Something went wrong!");
    return false;
  }
};

export const handleForgotPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
  } catch (error) {
    console.error("Error sending password reset email:", error.message);
  }
};

export const handleResetPassword = async (oobCode, newPassword) => {
  try {
    await confirmPasswordReset(auth, oobCode, newPassword);
  } catch (error) {
    console.error("Error resetting password:", error);
    alert("Error resetting password. Please try again.");
  }
};
